
import EtsyIntegrationCard from "@/components/EtsyIntegrationCard";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

interface DemoPageHeaderProps {
  title: string;
  description: string;
  children?: React.ReactNode;
}

const DemoPageHeader = ({ 
  title, 
  description, 
  children 
}: DemoPageHeaderProps) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          <p className="text-gray-600 mt-2">{description}</p>
        </div>
      </div>

      {/* No SubscriptionGuard for demo pages */}
      <EtsyIntegrationCard 
        isConnected={true} 
        onConnectionChange={() => {}} 
      />

      {/* Demo Features Overview */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-purple-600" />
            What You Can Do With Our Platform
          </CardTitle>
          <CardDescription>
            Explore all the features available with a premium subscription
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="text-center p-4 border rounded-lg">
              <div className="font-semibold mb-2">Order Management</div>
              <div className="text-sm text-gray-600">Track, filter, and manage all your orders</div>
              <Link to="/demo-orders">
                <Button variant="outline" size="sm" className="mt-2">
                  View Demo Orders
                </Button>
              </Link>
            </div>
            
            <div className="text-center p-4 border rounded-lg">
              <div className="font-semibold mb-2">Product Analytics</div>
              <div className="text-sm text-gray-600">Monitor sales, inventory, and performance</div>
              <Link to="/demo-products">
                <Button variant="outline" size="sm" className="mt-2">
                  View Demo Products
                </Button>
              </Link>
            </div>
            
            <div className="text-center p-4 border rounded-lg">
              <div className="font-semibold mb-2">Sales Reports</div>
              <div className="text-sm text-gray-600">Detailed analytics and insights</div>
              <Link to="/demo-reports">
                <Button variant="outline" size="sm" className="mt-2">
                  View Demo Reports
                </Button>
              </Link>
            </div>
            
            <div className="text-center p-4 border rounded-lg">
              <div className="font-semibold mb-2">Real-time Sync</div>
              <div className="text-sm text-gray-600">Automatic updates from your Etsy store</div>
              <Badge className="mt-2 bg-green-100 text-green-800">Live Updates</Badge>
            </div>
          </div>
        </CardContent>
      </Card>

      {children}
    </div>
  );
};

export default DemoPageHeader;
